// extracted by mini-css-extract-plugin
export default {"note":"Marginalia_note__9c0jz","slash":"Marginalia_slash__D9F7y","right":"Marginalia_right__sg5uN","left":"Marginalia_left__Lm8Bt"};